import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalBody, ModalFooter } from './Modal';
import { useModal } from './useModal';

export function sleep(time: number) {
    return new Promise((resolve) => setTimeout(resolve, time));
}



let useAlertDisabled = true;
export function useAlert(): [(msg: string | JSX.Element | JSX.Element[]) => Promise<void>, JSX.Element] {
    const [createModal, jsx, close] = useModal(() => {
        useAlertDisabled = true;
    }, true);


    const alert = (val: string | JSX.Element | JSX.Element[]) => {
        useAlertDisabled = false;
        createModal(
            <>
                <ModalBody>
                    {val}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary" onClick={close}>
                        <FormattedMessage id="close" defaultMessage="OK" description="alert close" />
                    </button>
                </ModalFooter>
            </>
        );


        return new Promise<void>((resolve) => {

            async function waitReturn() {
                await sleep(1);
                while (!useAlertDisabled) {
                    await sleep(1);
                }
                resolve();
            }

            waitReturn();
        })
    }

    return [alert, jsx]
}

let useConfirmDisabled = true;
let choose = false;
export function useConfirm(): [(msg: string | JSX.Element | JSX.Element[]) => Promise<boolean>, JSX.Element] {
    const [createModal, jsx, close] = useModal(() => {
        useConfirmDisabled = true;
    }, true);

    const confirm = (val: string | JSX.Element | JSX.Element[]) => {
        useConfirmDisabled = false;

        createModal(
            <>
                <ModalBody>
                    {val}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-primary" onClick={() => {
                        choose = true;
                        close()
                    }}>
                        <FormattedMessage id="yes" defaultMessage="YES" description="confirm yes" />
                    </button>
                    <button type="button" className="btn btn-secondary" style={{marginLeft: 25}} onClick={() => {
                        choose = false;
                        close()
                    }}>
                        <FormattedMessage id="no" defaultMessage="NO" description="confirm no" />
                    </button>
                </ModalFooter>
            </>
        );

        return new Promise<boolean>((resolve) => {

            async function waitReturn() {
                await sleep(1);
                while (!useConfirmDisabled) {
                    await sleep(1);
                }
                resolve(choose);
            }

            waitReturn();
        })
    }

    return [confirm, jsx]
}

export default function Message() {
    return (
        <div id="message-root" />
    )
}